import { render, staticRenderFns } from "./ListStock.vue?vue&type=template&id=4009a5f2&scoped=true&"
import script from "./ListStock.vue?vue&type=script&lang=ts&"
export * from "./ListStock.vue?vue&type=script&lang=ts&"
import style0 from "./ListStock.vue?vue&type=style&index=0&id=4009a5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4009a5f2",
  null
  
)

export default component.exports